export default __webpack_public_path__ + "static/media/TF_12.3d2715e7.png";